import * as React from 'react';

const ChevronSprite = (props) => (
    <svg
        {...props}
        fill='none'
        height={16}
        viewBox='0 0 32 16'
        width={32}
        xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M21.4837 14.3842L27.0721 8.79583C27.5115 8.35649 27.5115 7.64418 27.0721 7.20484L21.4835 1.61621L20.5996 2.50009L26.0999 8.00034L20.5999 13.5003L21.4837 14.3842Z'
            fill='currentColor'/>
        <path
            d='M5.48374 14.3842L11.0721 8.79583C11.5115 8.35649 11.5115 7.64418 11.0721 7.20484L5.48349 1.61621L4.59961 2.50009L10.0999 8.00034L4.59985 13.5003L5.48374 14.3842Z'
            fill='currentColor'/>
    </svg>
);

export default ChevronSprite;
